// packages/content/src/assets/items.ts (M1-T01) — pinned in §7.4; the kits have no rod, shovel or letter
import type { AssetBank } from '../schema/assets';
export default {
  'tool.rod': { src: 'code:rod' }, 'tool.shovel': { src: 'code:shovel' },
  'paper.plain': { src: 'code:letter' }, 'wrap.plain': { src: 'code:letter', params: { wrapped: true } },
} satisfies AssetBank;
